import { render } from "./FormFieldPackaging.vue?vue&type=template&id=1cf2ac58&scoped=true"
import script from "./FormFieldPackaging.vue?vue&type=script&lang=js"
export * from "./FormFieldPackaging.vue?vue&type=script&lang=js"

import "./FormFieldPackaging.vue?vue&type=style&index=0&id=1cf2ac58&scoped=true&lang=css"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf2ac58"]])

export default __exports__